import { accountId } from '@/lib/jwt';
import store from '@/store';

export function sessionStorageOrNull(): Storage | null {
  try {
    if (typeof window === 'undefined' || !window.sessionStorage) {
      return null;
    }
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function currentAccountId(): string | null {
  try {
    const fromJwt = accountId();
    if (fromJwt) {
      return fromJwt;
    }
  } catch {
    // fall through to store
  }

  try {
    const fromStore = store.getters?.['account/getAccount']?.id;
    return typeof fromStore === 'string' && fromStore.length > 0 ? fromStore : null;
  } catch {
    return null;
  }
}
